import Vue from 'vue';
import Router from 'vue-router';

import Landing from '@/app/pages/Landing';
import Explain from '@/app/pages/Explain';
import Game from '@/app/pages/Game';
import Naw from '@/app/pages/Naw';
import Thanks from '@/app/pages/Thanks';

Vue.use( Router );

var appRouter = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Landing',
            component: Landing
        },
        {
            path: '/uitleg',
            name: 'Explain',
            component: Explain
        },
        {
            path: '/game',
            name: 'Game',
            component: Game
        },
        {
            path: '/gegevens',
            name: 'Naw',
            component: Naw
        },
        {
            path: '/bedankt',
            name: 'Thanks',
            component: Thanks
        }

    ]
});

appRouter.beforeEach( ( to, from, next ) =>
{
    if( typeof to.beforeEnter === 'function' ) // check if the route has a beforeEnter function
    {
        to.beforeEnter( to, from, next );
        return;
    }

    next();
});

export default appRouter;



// WEBPACK FOOTER //
// ./src/app/router.js